import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { Media as BreakpointsMedia } from 'react-breakpoints';
import LoadingOverlay from "react-loading-overlay";
import {PulseLoader} from "react-spinners";

import VehicleSelector from "../../../../common/components/VehicleSelector";
import MyPageRadioGroup from "../../../../common/components/MyPageRadioGroup";
import MyPageRadioButton from "../../../../common/components/MyPageRadioButton";
import MyPageContainer from "../../../../common/components/MyPageContainer";
import ProductCard from "../../../../common/components/ProductCard";
import Fit2YouCard from "./Fit2YouCard";

import './PromotionsView.css'
import Section from "../../../../common/components/Section";
import {FilesLabeledIcon} from "../../../../common/icons";
import {addDays} from "date-fns";

@withRouter
@inject('translationsStore', 'mypageStore')
@observer
class PromotionsView extends Component {
  componentDidMount = () => {
    const {mypageStore} = this.props;
    mypageStore.loadAvailableProducts();
  };

  handleProductSelection = product => {
    const {mypageStore, history } = this.props;
    mypageStore.setSelectedProduct(product);
    if(this.isBlackBox(product)) {
      if(this.isMoveIn(product)) {
        history.push('/movein/installer');
      } else {
        history.push('/optional-services');
      }
    } else {
      history.push('/buy-airclub');
    }
  };

  isExpiring = (subscription) => {
    return subscription && subscription.node && new Date(subscription.node.end_date) < addDays(new Date(), 30);
  };

  isGrayed = (product) => {
    const {mypageStore} = this.props;
    const subscription = !!mypageStore.selectedManageableVehicle.subscriptions && mypageStore.selectedManageableVehicle.subscriptions.find(sub => sub.product.uuid === product.uuid);
    return subscription && !this.isExpiring(subscription);
  };

  getProducts = () => {
    const {mypageStore} = this.props;

    if(!mypageStore.selectedManageableVehicle) return [];

    const products = mypageStore.remoteUserIsFromMoVeInProgram
      ? mypageStore.availableProducts.filter(prod => !this.isBlackBox(prod) || this.isMoveIn(prod))
      : mypageStore.availableProducts.filter(prod => !this.isBlackBox(prod) || !this.isMoveIn(prod))

    return !this.hasBlackBoxSub()
      ? products.filter(this.isBlackBox)
      : this.filterProducts(products)
  };

  hasBlackBoxSub = () => {
    return this.props.mypageStore.selectedManageableVehicle.subscriptions.some(sub =>
      sub.product.features.some(feat => feat.node.name === 'black-box')
    )
  };

  isSubscribed = (product, subscriptions) => {
    return subscriptions.some(sub => sub.product.uuid === product.uuid);
  };

  hasSubscribedFeature = (product, subscriptions) => {
    const subscribedFeatures = subscriptions.reduce((acc, sub) => ([...acc, ...sub.product.features.map(f => f.node.uuid)]), []);
    return product.features.some(feature => subscribedFeatures.includes(feature.node.uuid));
  };


  filterProducts = (products) => {
    const subscriptions = this.props.mypageStore.selectedManageableVehicle.subscriptions;

    return products.filter(product =>
      this.isSubscribed(product, subscriptions) || !this.hasSubscribedFeature(product, subscriptions));
  };

  isMoveIn = (product) => {
    return product.features.some(feature => feature.node.name === 'movein')
  };

  isBlackBox = (product) => {
    return product.features.some(feature => feature.node.name === 'black-box')
  };

  render() {
    const { mypageStore, translationsStore } = this.props;


    const products = this.getProducts();

    return (
      <MyPageContainer className='ServicesView PromotionsView' dataCollection={this.props.dataCollection}>
        <LoadingOverlay
          active={mypageStore.loadingAvailableProducts}
          spinner={<PulseLoader sizeUnit={'px'} size={10} color={'var(--action-primary-color)'} loading={true} />}
          styles={{
            overlay: base => ({
              ...base,
              background: 'var(--grey-light-color-50)'
            })
          }}
        >
          <VehicleSelector />

          <Section title={translationsStore.translate('promotionsView.subTitle')}>
          </Section>

          <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-between"}}>
            {
              products
                .filter(product => !this.isGrayed(product))
                .map((product, index) =>
                <ProductCard
                  key={index}
                  subscriptions={mypageStore.selectedManageableVehicle.subscriptions}
                  onSelect={this.handleProductSelection}
                  product={product}
                />
              )
            }
            <Fit2YouCard
              logo="Fit2you_RC"
              features={["fit2you_RC"]}
            />
            <Fit2YouCard
              logo="Fit2you_CVT"
              features={["fit2you_CVT"]}
            />
          </div>
        </LoadingOverlay>
      </MyPageContainer>
    );
  }
}

export default PromotionsView;
